import { useState } from "react";

/**
 * 模型选择相关状态 Hook
 */
const useModelSelectionState = () => {
  const [modelType, setModelType] = useState("noReasoning"); // 默认选中Basic
  const [isAdvancedUnlocked, setIsAdvancedUnlocked] = useState(false); // Advanced模式解锁状态
  const [advancedPassword, setAdvancedPassword] = useState(""); // 用户输入的密码

  // 重置模型选择状态
  const resetModelSelectionState = () => {
    setModelType("noReasoning");
    setIsAdvancedUnlocked(false);
    setAdvancedPassword("");
  };

  return {
    modelType,
    setModelType,
    isAdvancedUnlocked,
    setIsAdvancedUnlocked,
    advancedPassword,
    setAdvancedPassword,
    resetModelSelectionState,
  };
};

export default useModelSelectionState;
